import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  Dropdown,
  DropdownInheritableProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {useLinkNavigation} from '../../../../../libs/shared/ui/src/components/navigation/useLinkNavigation';
import {MacrosBaseModel} from '../../../../models/api/macroModel';
import {SettingsRuleResourcePagesEnum} from '../../../../models/url/models/rulesUrlModel';
import {SettingsResourcePagesEnum, SettingsRootPagesEnum} from '../../../../models/url/models/types';
import {buildSettingsPath} from '../../../../models/url/settingsUrlHelpers';

/*
 * Props.
 */

export interface MacroPreviewDropdownProps extends DropdownInheritableProps {
  onClose: () => void;
  macro: MacrosBaseModel;
}

/*
 * Component.
 */

export const MacroPreviewDropdown: FC<MacroPreviewDropdownProps> = ({anchor, placement, onClose, macro}) => {
  const {navigateToLink} = useLinkNavigation();
  return (
    <Dropdown anchor={anchor} placement={placement} width={160} onRequestClose={() => onClose()}>
      <DropdownList>
        <DropdownItem onSelect={() => openInSettings(navigateToLink, macro)}>
          <DropdownItemContent>
            <Trans id="dropdown-macros-edit-settings">Edit in Settings</Trans>
          </DropdownItemContent>
        </DropdownItem>
      </DropdownList>
    </Dropdown>
  );
};

/*
 * Helpers.
 */

function openInSettings(navigate: (arg: string) => void, macro: MacrosBaseModel) {
  const editUrl = buildSettingsPath({
    namespace: macro.namespace,
    macroId: macro.id,
    rootPage: SettingsRootPagesEnum.RULES,
    resourcePage: SettingsRuleResourcePagesEnum.MACROS,
    subResourcePage: SettingsResourcePagesEnum.EDIT,
  });
  return navigate(editUrl);
}
